module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.scss
// module id = ./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.scss
// module chunks = 0